import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../Components/ui/card';
import { Heading } from '../Components/ui/typography';
import { Checkbox } from '../Components/ui/checkbox';
import { Label } from '../Components/ui/label';
import { Stack } from '../Components/ui/layout';
import { Separator } from '../Components/ui/separator';

const JobFilters = () => {
  const filterCategories = [
    { title: 'Date', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/7fbe51ee7ded4a1a359b176b59a00ef4777b2d0ac68abdfeeb56017331725960?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['Past 3 days', 'Past week', 'Past month', 'All'] },
    { title: 'Level', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/a8d1d326aaf46796a2d59afa461159950629f8dce8ce5fc84aba74ab8548ee87?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['Internship', 'Entry & mid-level', 'Senior', 'Senior ++', 'Director', 'VP', 'SVP/CXO'] },
    { title: 'Tech Sectors', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/dcc33ae1a4586783998041ca1c2c9babc559dd38ef64c5b3d47689606db88df2?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['Fin Tech', 'AI/ML', 'Software', 'Security', 'Game Tech', 'Open Source', 'Robotics'] },
    { title: 'Company Stage', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/41d972df1f6b3c93595baf4822868b84fb74ef5e79585a2037da086b421fb71f?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['Early-Stage Startup', 'Unicorn', 'Public Tech', 'FAANG+', 'Other'] },
    { title: 'Company List', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/c103620a239b1c78f19ddb25c391c998ab4bd0ec7bcb3ca3e41c424c85de03d2?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['User-friendly ATS', 'Tier-1 Comp', 'No Recent Layoffs', 'Salary Listed', 'IPO Watch list', 'Remote 250', 'Hot 250'] },
    { title: 'Company Type', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/833e9e78ac4dcd3a981dc9829542ae4c03079185f4e1f0acde21f6eea77f5414?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['Public', 'Private'] },
    { title: 'Customer Type', icon: 'https://cdn.builder.io/api/v1/image/assets/TEMP/41d972df1f6b3c93595baf4822868b84fb74ef5e79585a2037da086b421fb71f?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f', options: ['B2B', 'B2C'] },
  ];

  return (
    <Card className="w-80 sticky top-5 max-h-[calc(100vh-2.5rem)] overflow-y-auto">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-2xl">
          <img 
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/ae380bbfb49fa240f9d684fed4224f4662c92681fe0a6d182e0c442f98f53469?placeholderIfAbsent=true&apiKey=e90a33775c2844879a20708b8df7376f" 
            alt="" 
            className="w-6 h-6" 
          />
          Filters
        </CardTitle>
      </CardHeader>
      <CardContent>
        <Stack spacing="lg">
          {filterCategories.map((category, index) => (
            <div key={index}>
              <Heading level="h3" className="flex items-center gap-2 text-lg font-medium mb-3 text-muted-foreground">
                <img src={category.icon} alt="" className="w-5 h-5" />
                {category.title}
              </Heading>
              <Stack spacing="sm">
                {category.options.map((option, optionIndex) => (
                  <div key={optionIndex} className="flex items-center space-x-2">
                    <Checkbox id={`${category.title}-${optionIndex}`} />
                    <Label 
                      htmlFor={`${category.title}-${optionIndex}`}
                      className="text-sm font-normal cursor-pointer hover:text-primary transition-colors"
                    >
                      {option}
                    </Label>
                  </div>
                ))}
              </Stack>
              {index < filterCategories.length - 1 && <Separator className="mt-4" />}
            </div>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default JobFilters;